import { render, staticRenderFns } from "./VoiceClassCreateForm.vue?vue&type=template&id=17790d6e&scoped=true&"
import script from "./VoiceClassCreateForm.vue?vue&type=script&lang=ts&"
export * from "./VoiceClassCreateForm.vue?vue&type=script&lang=ts&"
import style0 from "./VoiceClassCreateForm.vue?vue&type=style&index=0&id=17790d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17790d6e",
  null
  
)

export default component.exports